export const DefaultQueryParams = {
  Token: 'token',
  UserId: 'userid',
  GameId: 'gameid',
  GameTypeId: 'gametypeid',
  ExitUrl: 'exiturl',
  PartnerId: 'partnerid',
  Currency: 'currency',
  PlayerExternalId: 'playerexternalid',
  PlayerId: 'playerexternalid',
  Mode: 'mode',
  CurrencySymbol: 'currencysymbol',
  Culture: 'culture', // instead of LANGUAGE
};
